import mixpanel from "mixpanel-browser";

import { handleSubscribe } from "../../../api/Billing";
import { UNLIMITED_PRICE_ID_MONTHLY } from "../../../constants";
import { useNoteUsage } from "../../../hooks";
import { ConfirmModal } from "../../common/modals/PopupModals";

function BlockOrWarnFreeUsage({
  isFullBlock,
  numAppointmentsUsed,
  numAppointmentsAllowed,
}) {
  return (
    <div className="text-sm space-y-2">
      {isFullBlock ? (
        <p>You've reached your trial limits on:</p>
      ) : (
        <p>
          You've almost reached your Auto-Note limit (
          {numAppointmentsUsed}/{numAppointmentsAllowed}). You'll need
          to upgrade your account soon to continue using:
        </p>
      )}
      <ul className="list-disc list-inside">
        <li>Adaptive Templates</li>
        <li>Medical Record SOAPs</li>
        <li>Multi-Pet SOAPs</li>
        <li>Pack Mode SOAPs</li>
      </ul>

      {isFullBlock ? (
        <p>
          Continue recording with <i>I'll Upgrade Later</i>. You won't
          be able to convert the recording into your selected Template
          until you upgrade.
        </p>
      ) : (
        <p>You'll need to upgrade your account soon to continue.</p>
      )}
    </div>
  );
}

export default function NoteUsageWarningModal({
  warningLevel,
  setWarningLevel,
  startRecording,
}) {
  if (!warningLevel) {
    return null;
  }
  const { numAppointmentsUsed, numAppointmentsAllowed } =
    useNoteUsage();
  const dismissModal = () => setWarningLevel(null);
  const shouldShow = ["warning", "limit"].includes(warningLevel);
  if (!shouldShow) {
    return null;
  }
  return (
    <ConfirmModal
      shouldShow={shouldShow}
      hideModal={dismissModal}
      title={"Upgrade Account"}
      cancelText={"I'll Upgrade Later"}
      confirmText={"Upgrade"}
      cancelAction={() => {
        dismissModal();
        startRecording(true);
      }}
      confirmAction={() => {
        mixpanel.track("Upgrade Clicked from modal");
        handleSubscribe({
          priceId: UNLIMITED_PRICE_ID_MONTHLY,
        });
        dismissModal();
      }}
    >
      {warningLevel == "limit" ? (
        <BlockOrWarnFreeUsage isFullBlock={true} />
      ) : (
        <h5>
          <BlockOrWarnFreeUsage
            isFullBlock={false}
            numAppointmentsUsed={numAppointmentsUsed}
            numAppointmentsAllowed={numAppointmentsAllowed}
          />
        </h5>
      )}
    </ConfirmModal>
  );
}
